import React, { FC } from "react";
import { UseFormReturn, useFieldArray } from "react-hook-form";
import {
	AddonApi,
	SubscriptionApi,
	UpdateAddonApi,
	UpdateSubscriptionsApi,
} from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { PriceConfiguratorAddonApi, PriceConfiguratorContentApi } from "../../../../../../../../services/Api/types";
import MonthlyAddons from "./MonthlyAddons";
import { defaultAddon } from "./services";

interface Props {
	estimate?: SubscriptionApi;
	config: PriceConfiguratorContentApi;
	form: UseFormReturn<UpdateSubscriptionsApi>;
	index: number;
	handleRemoveAddonTermsNames: (index: number) => void;
	estimating: boolean;
}

const ActiveSubscriptionMonthlyAddonsForm: FC<Props> = (props: Props) => {
	const { control, setValue, watch } = props.form;
	const { fields, remove, append } = useFieldArray({
		control,
		name: `subscriptions.${props.index}.monthly_sub_item.addons`,
	});

	const watchedPlan = watch(`subscriptions.${props.index}.plan_id`);
	const watchedPeriod = watch(`subscriptions.${props.index}.billing_period`);
	const plan = props.config?.plans.find((f) => f.plan_id === watchedPlan);
	const planAddons = props.config?.plans
		.find((f) => f.plan_id === watchedPlan)
		?.addons?.filter((f) => f.monthly_sub_details);

	if (!planAddons || planAddons.length <= 0) return null;

	const isSubscriptionEditable = plan?.edit_mode === "EDITABLE";

	const handleRemove = (addon: AddonApi, index: number) => {
		remove(index);
		props.handleRemoveAddonTermsNames(index);
	};
	const handleAdd = async (configAddon: PriceConfiguratorAddonApi) => {
		const newAddon = defaultAddon(configAddon);
		const exist = fields?.find((f) => f.addon_id === newAddon.addon_id);
		if (!exist) {
			remove();
			append([...(fields as UpdateAddonApi[]), newAddon]);
		} else {
			const key = fields?.indexOf(exist);
			setValue(`subscriptions.${props.index}.addons.${key}`, newAddon);
		}
		// handleSave(getValues());
	};

	return (
		<>
			{watchedPeriod === "YEARLY" && planAddons && planAddons.length > 0 && (
				<MonthlyAddons
					fields={fields}
					index={props.index}
					form={props.form}
					configAddons={planAddons}
					estimate={props.estimate}
					handleRemove={handleRemove}
					handleAdd={handleAdd}
					editable={isSubscriptionEditable}
					estimating={props.estimating}
				/>
			)}
		</>
	);
};
export default ActiveSubscriptionMonthlyAddonsForm;
